import React from "react";
import config from "../../../common/config";

const HelpTermsNConditions = () => {
  return (
    <div className="m11c-hp__row">
      <div className="m11c-static__wrap m11c-static__wrap--tnc">
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>IPL FANTASY GAME TERMS OF USE</span>
          </div>
          <div className="m11c-static__content">
            <div className="m11c-ptSyt__notes">
              <p>
                This webpage fantasy.iplt20.com (along with its sub-pages) (“
                <strong>Web Portal</strong>”) is owned and operated by the Board
                for Control of Cricket in India (“<strong>BCCI</strong>”).
                Through the Web Portal, the BCCI provides fantasy cricket games
                to users, where users are invited to build and act as owners of
                virtual squads (constituted of real players participating in the
                Indian Premier League (“<strong>IPL</strong>”)) that compete
                against virtual squads of other users (”<strong>Game</strong>
                (s)”). The Games are powered by Play Games24x7 Private Limited
                d/b/a My11Circle (“<strong>My11Circle</strong>”).
              </p>
              <p>
                The terms ‘Board of Control for Cricket in India’, ‘BCCI’ or
                ‘us’ or ‘we’ (unless the context of use suggests otherwise)
                refer to the BCCI in its capacity as the owner of this Web
                Portal and the operator of the Game. The term ‘you’ or ‘user(s)’
                refers to the user or viewer of our Web Portal and participants
                in the Games.
              </p>
              <p>
                By browsing, viewing or using the Web Portal or participating in
                the Games provided thereon you consent to and agree to comply
                with these terms and conditions of use (“<strong>Terms</strong>”
                or “<strong>Terms of Use</strong>”).
              </p>
              <p>
                The BCCI provides the Games subject to the notices, terms, and
                conditions set forth in these Terms of Use. In addition, when
                you participate in any of the Games, you will be subject to any
                more specific rules, guidelines, policies, terms, and conditions
                that are brought to your attention in the course of playing such
                specific Game, each of which will be deemed to be incorporated
                into these Terms of Use by reference. The BCCI reserves the
                right to change or modify the Web Portal, the Games, the
                contents thereof and these Terms of Use at any time. All
                modifications will be posted on the Web Portal and will become
                effective immediately upon such posting to the Web Portal.
                Please review these Terms of Use regularly to remain informed of
                any updates and changes.
              </p>
              <p>
                ACCESSING, BROWSING OR OTHERWISE USING THE WEB PORTAL OR
                REGISTERING FOR THE GAMES INDICATES YOUR AGREEMENT TO ALL THE
                TERMS AND CONDITIONS IN THESE TERMS, AS MODIFIED FROM TIME TO
                TIME. THEREFORE, PLEASE READ THESE TERMS CAREFULLY BEFORE
                PROCEEDING.
              </p>
            </div>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>1. Registration</span>
          </div>
          <div className="m11c-static__content">
            <div className="m11c-ptSyt__notes">
              <ul className="m11c-style--upper-alpha">
                <li>
                  You may participate in the Game on the Web Portal after
                  registering and creating an account with the Web Portal. The
                  Web Portal and services offered thereon are available to the
                  residents of India and any person located outside India. Any
                  person located outside India and part of{" "}
                  <a href="https://www.gdpradvisor.co.uk/gdpr-countries">
                    this list
                  </a>
                  of countries is not permitted to register on the Web Portal,
                  access or use the services offered thereon or provide personal
                  information to us.
                </li>
                <li>
                  Additionally, by registering you are confirming that you have
                  read and agree to these Terms of Use.
                </li>
                <li>
                  The information sought at the time of registration may include
                  your mobile number, full name, email, date of birth, country
                  of residence, state of residence and address. You hereby
                  consent to provide us with such information and agree/accept
                  that we may transfer such information from your country or
                  jurisdiction to other countries or jurisdictions around the
                  world in accordance with applicable law in India, including
                  the Digital Personal Data Protection Act, 2023.
                </li>
                <li>
                  You agree to provide true, accurate and current information
                  for the purpose of creating the account at the time of
                  registration and agree to maintain the accuracy and truth of
                  such information during the course of using the Web Portal
                  and/or participating in the Games. Users further agree to
                  update and keep updated their user account information at all
                  times.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>2. Web Portal Content</span>
          </div>
          <div className="m11c-static__content">
            <div className="m11c-ptSyt__notes">
              <ul className="m11c-style--upper-alpha">
                <li>
                  All materials, including illustrations, marks, statements,
                  opinions, written content, views, photographs, player
                  profiles, products, images, artwork, designs, text, graphics,
                  logos, button icons, images, flash animations, links, audio
                  and video clips and software which is powered by third party
                  (collectively, “<strong>Content”</strong>) are protected by
                  copyrights, trademarks and other intellectual property rights
                  that are owned and controlled by us, or our partners, or by
                  other parties that have licensed their material to us. Except
                  where otherwise agreed in writing with the BCCI in writing,
                  material on the Web Portal and Games is solely for your
                  personal, non-commercial use. You must not copy, reproduce,
                  republish, upload, post, transmit or distribute such material
                  in any way, including by e-mail or other electronic means,
                  whether directly or indirectly; and you must not assist any
                  other person to do so. Without the prior written consent of
                  the BCCI, modification of the materials, use of the materials
                  on any other web site or networked computer environment or use
                  of the materials for any purpose other than personal,
                  non-commercial use is a violation of these Terms as well as
                  copyrights, trademarks and other proprietary rights, and is
                  prohibited. To clarify, any use for which you receive any
                  remuneration, whether monetary or otherwise, is a commercial
                  use for the purposes of this clause.
                </li>
                <li>
                  This Web Portal may contain user generated Content provided by
                  third parties, including (without limitation) other users.
                  Responsibility for such Content is solely that of the
                  authors/contributors/posters and such Content is not endorsed
                  in any manner by the BCCI. The BCCI shall not be responsible
                  for or liable in any manner whatsoever for the Content
                  provided by such authors/contributors/posters in any section
                  of this Web Portal. Further, the accuracy of the Content has
                  not been verified by the BCCI and we provide no warranties
                  with respect to the same. If you seek to rely on any third
                  party or user generated representation of information
                  contained on this Web Portal, any such reliance shall be at
                  your own risk.
                </li>
                <li>
                  The user is responsible for any content, picture, logo, emblem
                  or other materials posted or transmitted to the Web Portal in
                  the course of availing the Games. You hereby grant us a
                  worldwide, royalty free, irrevocable, non-exclusive,
                  transferable, assignable and sub-licensable license to use any
                  content posted by you or published by the BCCI, in any part of
                  the world, or to be used for any reason by the BCCI, including
                  for the creation of derivative works that might include such
                  content, consistent with these Terms, and you are not entitled
                  to any payment or other compensation for such use.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>3. Provision of Games</span>
          </div>
          <div className="m11c-static__content">
            <div className="m11c-ptSyt__notes">
              <ul className="m11c-style--upper-alpha">
                <li>
                  Through the Web Portal, the BCCI enables users to build and
                  act as owners of virtual squads (constituted of real players
                  from IPL franchisees) that compete against virtual squads of
                  other users, with points attributed to the virtual players
                  and, in aggregate, to the virtual squads on the basis of the
                  performance of the real players in matches of the IPL.
                </li>
                <li>
                  THE GAMES ARE PROVIDED TO USERS FOR FREE WITHOUT THE PAYMENT
                  OF ANY FEE OR CHARGE FOR PARTICIPATION.
                </li>
                <li>
                  BCCI reserves the right, to be exercised at its sole and
                  absolute discretion, to:
                  <ul className="m11c-style--lower-roman">
                    <li>
                      Deactivate or delete a user’s account and all related
                      information and files on the account;
                    </li>
                    <li>
                      Suspend, terminate or otherwise restrict a user’s access
                      to all or any part of the Web Portal or the Games;
                    </li>
                    <li>
                      Change, alter or amend the terms, format or conditions of
                      the Games or the whole of or any part of the Web Portal or
                      the Games.
                    </li>
                  </ul>
                </li>
                <li>
                  Squad Selection for all Formats of the Game
                  <ul className="m11c-style--lower-roman">
                    <li>
                      Users may draft virtual squads composed of 11 players from
                      the pool of real-world players made available for
                      selection by the BCCI on this Web Portal and the format of
                      the Game and such virtual squad shall be attached to their
                      user account. The selection and drafting of the virtual
                      squad of each user shall be subject to the constraints set
                      out below. Each player made available by the BCCI for
                      selection and drafting into the virtual squad will be
                      attributed a price, categorized on the basis of (1)
                      nationality (either as an ‘overseas’ or ‘Indian’ player),
                      (2) playing role (either as a ‘batter’, ‘all-rounder’,
                      ‘wicketkeeper’ or ‘bowler’, (3) engagement with an IPL
                      franchisee.
                    </li>
                    <li>
                      The attribution of a price to each player made available
                      for selection, and/or the classification of such player
                      into a particular role based category, and/or any other
                      attributes or classifications of the player, is subject to
                      the sole and absolute discretion of the BCCI, and the BCCI
                      reserves the right to alter, modify or change the price or
                      classification of each player, and/or remove such player
                      from the roster of available players for selection from
                      time to time at its sole and absolute discretion.
                    </li>
                    <li>
                      For the purposes of the selection and drafting of a
                      virtual squad, each user shall be provided with a total of
                      100 credits. When drafting a virtual squad, the user must
                      operate within this budget and must draft 11 players to
                      form the virtual squad. The squad selection process must
                      also ensure compliance with the following stipulations:
                      {/* <p>
                        <strong>1.</strong> For Season Long Fantasy
                      </p>
                      <ul className="m11c-style--lower-roman__text">
                        <li>
                          <strong>a.</strong> 3 (minimum) to 6 (maximum) players
                          classified as ‘batters’;
                        </li>
                        <li>
                          <strong>b.</strong> 1 (minimum) to 4 (maximum) players
                          classified as ‘all-rounders’;
                        </li>
                        <li>
                          <strong>c.</strong> 1 (minimum) to 4 (maximum) players
                          classified as ‘wicket-keepers’;
                        </li>
                        <li>
                          <strong>d.</strong> 3 (minimum) to 6 (maximum) players
                          classified as ‘bowlers’.
                        </li>
                      </ul>{" "} */}
                      <p>
                        <strong>1.</strong> For Season Long Fantasy
                      </p>
                      <ul className="m11c-style--lower-roman__text">
                        <li>
                          <strong>a.</strong> 3 (minimum) to 6 (maximum) players
                          classified as ‘batters’;
                        </li>
                        <li>
                          <strong>b.</strong> 1 (minimum) to 4 (maximum) players
                          classified as ‘all-rounders’;
                        </li>
                        <li>
                          <strong>c.</strong> 1 (minimum) to 4 (maximum) players
                          classified as ‘wicket-keepers’;
                        </li>
                        <li>
                          <strong>d.</strong> 3 (minimum) to 6 (maximum) players
                          classified as ‘bowlers’.
                        </li>
                      </ul>
                      <p>
                        <strong>2.</strong> For Daily Fantasy
                      </p>
                      <ul className="m11c-style--lower-roman__text">
                        <li>
                          <strong>a.</strong> 1 (minimum) to 8 (maximum) players
                          classified as ‘batters’;
                        </li>
                        <li>
                          <strong>b.</strong> 1 (minimum) to 8 (maximum) players
                          classified as ‘all-rounders’;
                        </li>
                        <li>
                          <strong>c.</strong> 1 (minimum) to 8 (maximum) players
                          classified as ‘wicket-keepers’;
                        </li>
                        <li>
                          <strong>d.</strong> 1 (minimum) to 8 (maximum) players
                          classified as ‘bowlers’.
                        </li>
                      </ul>
                    </li>
                    <li>
                      Overseas Limit
                      <ul className="m11c-style--lower-roman__text">
                        <li>
                          <strong>1.</strong> For Season long fantasy, no
                          virtual squad can contain more than 4 ‘overseas’
                          players, at any given time.
                        </li>
                        <li>
                          <strong>2.</strong> For Daily fantasy, there is no
                          restriction on selection of ‘overseas’ players, at any
                          given time.
                        </li>
                      </ul>
                    </li>
                    <li>
                      Franchisee Spread – no virtual squad can contain more than
                      7 players from a single IPL franchisee (team), at any
                      given time.
                    </li>
                    <li>
                      Additionally, users can designate a player within their
                      virtual squads as a ‘Captain’, and the points attributed
                      to such player at the end of each matchday of the ‘Fantasy
                      League’ shall be doubled. A user must also designate a
                      player as a ‘Vice-Captain’, and the user will receive 1.5
                      times the points attributed to such player at the end of
                      each matchday. Subject to these Terms, users may change or
                      designate another player within their virtual squad as the
                      ‘Captain’ & ‘Vice-Captain’ at any time prior to the
                      commencement of a matchday or match of the IPL Fantasy
                      League game. Any changes to the designated Captain or
                      Vice-Captain made during the course of any matchday/ match
                      will only take effect for the next matchday.
                    </li>
                    <li>
                      The user can edit his/her virtual team till the start of
                      the official start time of the match.
                    </li>
                    <li>
                      In the event of more than one virtual squad having the
                      same cumulative score at the conclusion of the Fantasy
                      League, the winner will be decided on the basis of points
                      earned by the ‘Captain’ of the competing virtual squads.
                      If the virtual squads have the same ‘Captain’ (or the
                      ‘Captains’ have the same points), then the virtual squad
                      with the ‘Vice - Captain’ having higher score shall be
                      declared a winner. In the event of virtual squads having
                      the same ‘Captain’ and ‘Vice-Captain’ (or the ‘Captain’
                      and the ‘Vice-Captain’ have the same points), the winner
                      will be the virtual squad that was submitted first.
                    </li>
                    <li>
                      Boosters – Users will have the option to use the following
                      seven (7) boosters, each of which can be used only once
                      during the entire season:
                      <ul className="m11c-style--lower-roman__text">
                        <li>
                          <strong>1. Triple Captain:</strong> The captain now
                          earns triple points instead of the regular double for
                          a match.
                        </li>
                        <li>
                          <strong>2. Wildcard:</strong> Allows unlimited
                          transfers within a 100-credit budget for a match.
                        </li>
                        <li>
                          <strong>3. Impact Player:</strong> A designated
                          player, other than the captain, earns double points
                          for a match.
                        </li>
                        <li>
                          <strong>4. Double Points:</strong> The entire team
                          receives double points for a match.
                        </li>
                        <li>
                          <strong>5. Free Hit:</strong> Enjoy unlimited
                          transfers with no budget restrictions for a match.
                          After the match, your team reverts to the previous
                          line up.
                        </li>
                        <li>
                          <strong>6. Overseas Stars:</strong> All overseas
                          players playing in the current team earn double points
                          for a match.
                        </li>
                        <li>
                          <strong>7. Indian Warrior:</strong> All Indian players
                          playing in the current team earn double points for a
                          match.
                        </li>
                      </ul>
                    </li>
                    <li>
                      “In Starting Lineup” feature: The Web Portal may indicate
                      that a Player has been included in the final starting
                      lineup for a particular IPL match. The purpose of this
                      feature is only to provide information and assist a user
                      in selecting his/her team. Users are advised to do
                      thorough research and due diligence on their own and not
                      rely completely on the starting lineup feature provided on
                      the Web Portal. BCCI disclaims any and all liability, if a
                      player earlier indicated as ‘Playing’ does not play or
                      start for any reason whatsoever.
                    </li>
                  </ul>
                </li>
                <li>
                  Fantasy League (Season Long)
                  <ul className="m11c-style--lower-roman">
                    <li>
                      <ul className="m11c-style--lower-alpha">
                        <li>
                          The Fantasy League Game format runs for the duration
                          of the IPL, with points attributed to each player
                          selected in the virtual squad on the basis of their
                          performance in each match of the IPL. For
                          participation in the Fantasy League Game format, each
                          user account shall be permitted to draft one squad
                          alone.
                        </li>
                        <li>
                          At the end of the IPL Fantasy League, the winner will
                          be determined on the basis of the accumulated points
                          of each participating virtual squad, with the winning
                          virtual squad being the virtual squad that accumulates
                          the most number of points relative to the other
                          participating users’ virtual squads.
                        </li>
                        <li>
                          The Fantasy League format of the Game will be offered
                          by the BCCI in the following League, wherein each
                          participating user’s virtual squad will be
                          automatically placed into the Global League – which
                          shall comprise the virtual squads of all participating
                          users (of the Fantasy League Game format).
                        </li>
                        <li>
                          Restrictions on transfers: <br />
                          In this format of the Game, users may substitute
                          players within their virtual squads, within the
                          constraints set out as follows:
                          <ul className="m11c-style--upper-roman">
                            In this format of the Game, users may substitute
                            players within their virtual squads, within the
                            constraints set out as follows:
                            <li>
                              Before the user joins the Fantasy League Game, the
                              user can make unlimited changes to their virtual
                              squad.
                            </li>
                            <li>
                              If a user joins the IPL Fantasy League Game before
                              the commencement of match 35, user is allowed to
                              make 210 substitutions to their virtual squad up
                              to the commencement of match 70, which is the end
                              of the league stage of the IPL.
                            </li>
                            <li>
                              If a user joins the Fantasy League Game after the
                              commencement of match 35, user is allowed to make
                              105 transfers to their virtual squad up to the
                              commencement of match 70, which is the end of the
                              league stage of the IPL.
                            </li>
                            <li>
                              After the commencement of match 70 and before the
                              commencement of ‘Qualifier 1’, users can again
                              make unlimited transfers and changes.
                            </li>
                            <li>
                              After the commencement of ‘Qualifier 1’ and before
                              the commencement of the ‘Final’, users can make 10
                              transfers.
                            </li>
                            <li>
                              A user can make unlimited “Captain” and
                              “Vice-Captain” changes throughout the duration of
                              the Fantasy League.
                            </li>
                            <li>
                              It is clarified that while a user is permitted to
                              make transfers and replacements during the course
                              of any match of the IPL, all such transfers and
                              replacements shall only take effect for the next
                              match. Only transfers or replacements that take
                              place before the commencement of the match will
                              take effect for such a match.
                            </li>
                          </ul>
                        </li>
                        <li>
                          In case of any abandonment of a match for any reason,
                          the following consequences follow:
                          <ul className="m11c-style--upper-roman">
                            <li>
                              If a match is abandoned before it begins,
                              <ul>
                                <li>
                                  a. If a match is abandoned anytime, the system
                                  will behave as if the match has ended.
                                </li>
                                <li>
                                  b. Transfers and Booster deducted for the
                                  abandoned match will not be refunded.
                                </li>
                                <li>
                                  c. If a match gone live and fantasy points are
                                  accrued, points earned until the match has be
                                  abandoned will be retained.
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                        <li>
                          If a match is abandoned after it begins,
                          <ul className="m11c-style--upper-roman">
                            <li>
                              If a match is abandoned anytime, the system will
                              behave as if the match has ended.
                            </li>
                            <li>
                              Transfers and Booster deducted for the abandoned
                              match will not be refunded.
                            </li>
                            <li>
                              If a match gone live and fantasy points are
                              accrued, points earned until the match has be
                              abandoned will be retained.
                            </li>
                          </ul>
                        </li>
                        <li>
                          Playoffs League
                          <ul className="m11c-style--upper-roman">
                            <li>
                              Booster advantages except for Freehit and Wildcard
                              will be disabled in Playoffs Leagues to ensure
                              fair play and maintain a level playing field for
                              all participants. These advantages will only be
                              available in Global Leagues, Favourite Team
                              Leagues, and Private Leagues.
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  Fantasy League (Daily)
                  <ul className="m11c-style--lower-roman">
                    <li>
                      <ul className="m11c-style--lower-alpha">
                        <li>
                          The Fantasy League Game format runs for the duration
                          of the IPL, with points attributed to each player
                          selected in the virtual squad on the basis of their
                          performance in each match of the IPL. For
                          participation in the Fantasy League Game format, each
                          user account shall be permitted to draft one squad
                          alone for each match of the IPL.
                        </li>
                        <li>
                          At the end of the IPL match, the Fantasy League winner
                          will be determined on the basis of the accumulated
                          points of each participating virtual squad, with the
                          winning virtual squad being the virtual squad that
                          accumulates the most number of points relative to the
                          other participating users’ virtual squads.
                        </li>
                        <li>
                          The Fantasy League format of the Game will be offered
                          by the BCCI in the following League, wherein each
                          participating user’s virtual squad will be have to be
                          placed into the Global League by the user – which
                          shall comprise the virtual squads of all participating
                          users (of the Fantasy League Daily format).
                        </li>
                        <li>
                          Restrictions on transfers: <br />
                          In this format of the Game, users may substitute
                          players within their virtual squads, within the
                          constraints set out as follows:
                          <ul className="m11c-style--upper-roman">
                            <li>
                              Before the start of the IPL match, the user can
                              make unlimited changes to their virtual squad of
                              that match.
                            </li>
                            <li>
                              A user can make unlimited “Captain” and
                              “Vice-Captain” changes to their virtual squad of
                              that match
                            </li>
                            <li>
                              Once the IPL match commences or has gone live,
                              users virtual squads will be locked and users will
                              not be allowed to make any changes to their
                              virtual squad of that IPL match
                            </li>
                          </ul>
                        </li>
                        <li>
                          In case of any abandonment of a match for any reason,
                          the following consequences follow:
                          <ul className="m11c-style--upper-roman">
                            <li>
                              If a match is abandoned before it begins,
                              <ul>
                                <li>
                                  a. The user’s team is deleted from our system
                                  and there will be no contest to participate
                                  for that IPL match
                                </li>
                                <li>
                                  b. There will be no league and prizes on offer
                                  this abandoned IPL match
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                        <li>
                          If a match is abandoned after it begins,
                          <ul className="m11c-style--upper-roman">
                            <li>
                              The user’s team is deleted from our system and
                              there will be no contest to participate for that
                              IPL match
                            </li>

                            <li>
                              There will be no league and prizes on offer this
                              abandoned IPL match
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  In addition, users may elect to participate in invitational
                  ‘User Moderated Leagues’, as set out herein below:
                  <ul className="m11c-style--lower-roman">
                    <li>
                      The User Moderated League Game format is available to
                      participating users of the Fantasy League Game and this
                      format shall run for the duration of the IPL season.
                    </li>
                    <li>
                      In this format, any user can create a private league; the
                      private league shall be allotted a league invite code
                      which may be obtained from any member of the league. Other
                      users may participate in such private leagues by entering
                      the league invite code.
                    </li>
                    <li>
                      All rules and stipulations as to squad selection, duration
                      and substitution,as applicable to the Fantasy League Game
                      format, shall be applicable to each private league created
                      in this format. The user, acting through such user’s
                      account, shall not be entitled or permitted to draft a new
                      virtual squad for participation in any league under this
                      format of the Game, and shall use the same virtual squad
                      as drafted and attached to such user’s account for
                      participation in the Fantasy League Game format.
                    </li>
                    <li>
                      It is clarified that no user shall be entitled to claim or
                      demand any fee or charge for participation in any league
                      created by such user or where such user participates, and
                      no person shall be entitled to any prize or payment for
                      participating in and/or being declared the winner of any
                      such league.
                    </li>
                    <li>
                      A user can create and join into a maximum of 20 such User
                      Moderated Leagues. Participation in more than 20 such
                      leagues shall be automatically prohibited.
                    </li>
                    <li>
                      The creator of the private contest or administrator of the
                      league has the option to remove users who have joined the
                      league. Though, the admin can only remove users from the
                      league before they have started accumulating points post
                      joining the league. In the event the administrator of the
                      league decides to leave the league, the next user who has
                      joined the league will automatically be appointed as the
                      administrator.
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>4. Prizes</span>
          </div>
          <div className="m11c-static__content">
            <div className="m11c-ptSyt__notes">
              <ul className="m11c-style--upper-alpha">
                <li>
                  In the course of providing the Games, the BCCI may, at its
                  sole and absolute discretion, and on such terms as it deems
                  fit, provide prizes to users for participating and winning any
                  of the formats of the Games. The prizes for the Fantasy League
                  format, if any, shall be prominently displayed on the Web
                  Portal prior to the commencement of Match 1 of the IPL. The
                  BCCI shall not issue any cash prizes to the players
                  participating in the Game(s). The issuance of prizes is
                  subject to all applicable central, state and local laws and
                  regulations.
                </li>
                <li>
                  The issue of prizes by the BCCI are in recognition of the
                  skill of each user in, amongst others, (1) understanding the
                  game dynamics and the individual role of each player, (2)
                  ascertaining the opportunity cost of selecting one player
                  relative to the other players available for selection, (3)
                  employing his/her knowledge of the player and of such player’s
                  past performance to predict the points likely to be
                  attributable (in accordance with the stipulated points system)
                  to the player pursuant to such player’s performance in a real
                  world match, (4) selecting a squad of 11 players within the
                  constraints and limitations set out above to ensure the
                  maximization of points, and (5) continuing to monitor player
                  performance in the IPL and make substitutions to the virtual
                  squad to ensure the maximization of points, as evidenced from
                  the points accumulated by the virtual squad of such user
                  relative to that of the virtual squads of other participating
                  users in specified leagues and formats of the Games.
                </li>
                <li>
                  All users above the age of 18 years accessing the Web Portal
                  and/or Games from India are eligible to win prizes, subject to
                  applicable laws, including local laws of the state where the
                  user resides. Furthermore, in case any user is aged less than
                  18 years as on the date of participation in the Games, such
                  user is eligible to access the Web Portal, participate in the
                  Games and win prizes provided he/she has obtained the consent
                  of his/her parent or lawful guardian to participate in the
                  Games and accept prizes; in such circumstances, the BCCI
                  reserves the right to seek written documentation of such
                  consent of the parent or lawful guardian at any time as a
                  condition to such user’s continued use of the Web Portal or
                  participation in the Games or before disbursing prizes to such
                  minor user.
                </li>
                <li>
                  The issue of prizes shall be at the sole and absolute
                  discretion of the BCCI, and no user shall claim or be entitled
                  to claim or demand any prize as a matter of right. For the
                  purposes of clarification, Apple AppStore and Google Play
                  Store on which such Games may be provided are not sponsoring
                  any prizes and will be responsible to provide any prizes to
                  the winners. The decisions of the BCCI and their respective
                  agents, officers and contractors shall be final and binding in
                  all matters related to the issue of prizes in the formats of
                  the Games. The BCCI may substitute or change the prize offered
                  at any time without notice. Users may not substitute a prize
                  for other items or exchange for cash. Prizes issued hereunder
                  shall be non-transferrable.
                </li>
                <li>
                  The winner of each prize shall be announced within a
                  reasonable period of time after the completion of the league
                  or format of the Game in relation to which such prize is being
                  offered. The winners shall be notified by email to the account
                  specified in their account information or by publication on
                  the Web Portal. After notification by email, users shall have
                  7 days to respond, to verify their identity and residence (in
                  accordance with the procedure set out in the email
                  notification) and claim the prize from the BCCI in accordance
                  with the procedure set out in the email notification. However,
                  if winners cannot be contacted, are unavailable, or fail to
                  comply with these Terms, the prize issued to them shall stand
                  forfeited, and may thereafter be withdrawn or issued to the
                  next in line eligible user, at the sole and absolute
                  discretion of the BCCI. The BCCI is not obliged to inform such
                  a winning user of the disentitlement; however, it may choose
                  to bring the same to the notice of the winning user through
                  any of the means available to it.
                </li>
                <li>
                  All prizes will be delivered in India only. The cost of
                  delivery of the prize will be borne by the BCCI, provided that
                  the address for delivery of the same is in India. All taxes,
                  levies and duties due and owing under applicable and statutory
                  laws in connection with all prizes, if any, are the sole
                  responsibility of the winning users. Winning users hereby
                  undertake to provide and/or execute any documents as may be
                  deemed necessary by the BCCI to effectively issue the prizes
                  to such users in accordance with these Terms.
                </li>
                <li>
                  The BCCI or the third party service provider (as the case may
                  be) shall not be liable for any damage/loss/non-delivery of
                  any prize due to incorrect address; late, lost, illegible,
                  corrupted, incorrectly submitted communication, documents,
                  claims or correspondence due to error, omission, alteration,
                  tampering, unauthorized data hacking, deletion, theft,
                  destruction, virus attack, transmission interruption,
                  communications failure, hardware failure or otherwise; or any
                  other incorrect information provided or other user errors by
                  the winning user, and such causes may result in the
                  disentitlement of the winning user. The BCCI or the
                  third-party service provider (as the case may be) is not
                  obliged to inform such a winning user of the disentitlement;
                  however, it may choose to bring the same to the notice of the
                  winning user through any of the means available to it.
                </li>
                <li>
                  The BCCI or third-party service provider (as the case may be)
                  shall not be responsible for any cost, expense or other
                  liability whatsoever in relation to, arising from or connected
                  with the prize or its quality. The BCCI or the third-party
                  service provider (as the case may be) makes no representation
                  as to the quality, suitability or merchantability; and extends
                  no guarantee or warranty relating to prize. The BCCI or the
                  third-party service provider (as the case may be) shall not be
                  responsible for any injury (including death), loss, damage or
                  other consequence whatsoever arising from, suffered or
                  incurred by winning users from or in relation to the use of
                  the prize. The BCCI or third-party service provider (as the
                  case may be) assumes no responsibility for non-receipt of
                  prize by the winning user(s) or for any damage, loss, injury,
                  or disappointment suffered by any winning user or as a result
                  of accepting any prize.
                </li>
                <li>
                  All users registered from countries outside India or part of
                  <a href="https://www.gdpradvisor.co.uk/gdpr-countries">
                    this list{" "}
                  </a>
                  of countries are not eligible to win prizes. Users from
                  outside India if part of the winning rank will not be
                  considered for prizes and users in ranks below then will be
                  considered.
                </li>
                <li>
                  Nothing contained herein amounts to a commitment or
                  representation by the BCCI or My11Circle to conduct any
                  further promotions, competitions or issue any further prizes.
                </li>
                {/* <li>Apple and Google are not a sponsor of the prizes.</li> */}
              </ul>
            </div>
          </div>
        </div>

        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>5. Warranty and Liability Disclaimer </span>
          </div>
          <div className="m11c-static__content">
            <div className="m11c-ptSyt__notes">
              <ul className="m11c-style--upper-alpha">
                <li>
                  The BCCI is constantly endeavouring to improve the quality of
                  the Games provided to you on the Web Portal. Due to this, the
                  form and nature of Games provided may change from time to time
                  without any prior notice to you. The BCCI reserves the right
                  to introduce and initiate new features, functionalities,
                  components to the Web Portal and Games and/or change, alter,
                  modify, suspend, discontinue or remove the existing ones
                  without any prior notice to you. Further, BCCI is entitled to
                  discontinue (either permanently or temporarily) one or more of
                  the formats of the Games provided or terminate the Web Portal
                  without any prior notice to you.
                </li>
                <li>
                  The BCCI may also prescribe certain limits on the use of the
                  Web Portal and/or Games or storage of Content at its sole and
                  absolute discretion without any prior notice to you while at
                  all times complying with the BCCI’s Privacy Policy. In
                  consideration for BCCI granting you access to and use of the
                  Web Portal and Games, you agree that BCCI and its third-party
                  service providers and partners may place such advertising on
                  the Games or in connection with the display of Content or
                  information from the Games, whether submitted by them or
                  others.
                </li>
                <li>
                  The Web Portal, all the materials and services, included on or
                  otherwise made available to you through this Web Portal and
                  the Games is provided by the BCCI on an “as is” and “as
                  available” basis without any representation or warranties,
                  express or implied except otherwise specified in writing.
                  Without prejudice to the foregoing paragraph, the BCCI does
                  not warrant that:
                  <ul className="m11c-style--lower-roman">
                    <li>
                      This Web Portal and Games will be constantly available, or
                      available at all; or
                    </li>
                    <li>
                      The information on this Web Portal is complete, true,
                      accurate or not misleading.
                    </li>
                  </ul>
                </li>
                <li>
                  User agrees that the BCCI shall not be responsible to the user
                  where the user is unable to participate in the Game or make
                  changes or substitutions where the Web Portal or Games become
                  in-operational or are not accessible by the user for whatever
                  reason.
                </li>
                <li>
                  The BCCI, to the fullest extent permitted by law, disclaims
                  all warranties, whether express or implied, including the
                  warranty of merchantability, fitness for particular purpose
                  and non-infringement. The BCCI makes no warranties about the
                  accuracy, reliability, completeness, or timeliness of the Web
                  Portal, Games, Content, services, software, text, graphics and
                  links.
                </li>
                <li>
                  The BCCI does not warrant (1) that this Web Portal,
                  information, Content, materials, or Games included on or
                  otherwise made available to you through this Web Portal, its
                  servers, or electronic communication sent from by BCCI are
                  free of viruses or other harmful components or (2) that the
                  same will be available to you uninterrupted, timely or
                  error-free or (3) that defects will be corrected.
                </li>
                <li>
                  The BCCI and its partners shall not be liable for any injury,
                  loss, claim, loss of data, or loss of opportunity, general
                  damages or any direct, indirect, special, incidental,
                  consequential, exemplary or punitive damages of any kind
                  whatsoever arising out of or in connection with your access
                  to, or use of, or inability to access or use, the Web Portal
                  and the Games hosted on the Web Portal. You further agree to
                  indemnify us and our service providers against any claims in
                  respect of any such matter.Without limiting the generality of
                  the foregoing, you specifically acknowledge, agree and accept
                  that the BCCI and its partners shall not be liable to you for:
                  <ul className="m11c-style--lower-roman">
                    <li>
                      the defamatory, undesirable or illegal conduct of any
                      other users accessing or using the Games on the Web
                      Portal;
                    </li>
                    <li>
                      any loss whatsoever arising from the use, abuse or misuse
                      of your user account or any feature of our Games on the
                      Web Portal;
                    </li>
                    <li>
                      any technical failures, breakdowns, defects, delays,
                      interruptions, improper or manipulated data transmission,
                      data loss or corruption or communications infrastructure
                      failure, viruses or any other adverse technological
                      occurrences arising in connection with your access to or
                      use of our Games on the Web Portal;
                    </li>
                    <li>
                      the accuracy, completeness of any information services
                      provided on the Web Portal
                    </li>
                    <li>
                      any delay or failure on our part to intimate you where we
                      may have concerns about your activities.
                    </li>
                  </ul>
                  <li>
                    Nothing on this Web Portal constitutes, or is meant to
                    constitute, advice or opinion of any kind.
                  </li>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>6. Accuracy of Information</span>
          </div>
          <div className="m11c-static__content">
            <div className="m11c-ptSyt__notes">
              <ul className="m11c-style--upper-alpha">
                <li>
                  No representation is made, or warranty given as to the
                  completeness or accuracy of any information on this Web Portal
                  and/or the Games. The BCCI makes no representations about the
                  accuracy, reliability, completeness, or timelines of the Web
                  Portal or the Content. The use of the Web Portal and the
                  Content is at your own risk. The BCCI makes no commitment to
                  correct or update this information.
                </li>
                <li>
                  The computation and updation of virtual points at the end of
                  each match or round of the IPL, shall be done by the BCCI,
                  either by itself or through third party services providers.
                  However, the BCCI does not warrant or make any representations
                  concerning the accuracy or completeness of the tabulation of
                  virtual points (including with respect to the tabulation of
                  the scores with respect to each user’s virtual squad) and
                  shall not be responsible or liable for any inaccuracies in the
                  tabulated virtual points and scores or for the declaration of
                  winning users pursuant to any inaccurate or incomplete scores.
                  You agree not to make any claim or raise any complaint against
                  the BCCI in this respect.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>7. Indemnification</span>
          </div>
          <div className="m11c-static__content">
            <div className="m11c-ptSyt__notes">
              <ul className="m11c-style--upper-alpha">
                <li>
                  You represent, warrant and covenant (a) that no materials of
                  any kind provided or uploaded by you to the Web Portal and/or
                  the Games will (i) violate, plagiarise, or infringe upon the
                  rights of any third party, including copyright, trademark,
                  privacy or other personal or proprietary rights; or (ii)
                  contain abusive, grossly harmful, harassing, pedophilic,
                  blasphemous, pornographic, racially or ethnically
                  objectionable, disparaging, defamatory, obscene, salacious,
                  lascivious material, material relating or encouraging money
                  laundering or gambling or otherwise unlawful material or (iii)
                  otherwise violate these Terms of Use; and (b) that you (i) are
                  not and will not use the Web Portal or participate in the
                  Games for any illegal purpose; or (ii) have not and will not
                  levy any charge or collect a fee from any person to facilitate
                  their participation in the Games, or any part thereof.
                </li>
                <li>
                  You hereby agree to indemnify, defend and hold harmless the
                  BCCI and all of the BCCI’s officers, directors, owners,
                  agents, information providers, affiliates, licensors and
                  licensees, subcontractors and service providers (collectively,
                  the “<strong>Indemnified Parties</strong>”) from and against
                  any and all liability and costs, including, without
                  limitation, reasonable advocate's fees, incurred by the
                  Indemnified Parties in connection with any claim arising out
                  of any breach by you of these Terms or the foregoing
                  representations, warranties and covenants. You shall cooperate
                  as fully required in the defense of any such claim. The BCCI
                  reserves the right, at its own expense, to assume the
                  exclusive defense and control of any matter subject to
                  indemnification by you.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>8. Breach and Termination</span>
          </div>
          <div className="m11c-static__content">
            <div className="m11c-ptSyt__notes">
              <ul className="m11c-style--upper-alpha">
                <li>
                  The BCCI retains the right to deny access to the Web Portal
                  and/or the Games to anyone who it believes has violated any of
                  these Terms of Use or does not accept these Terms of Use.
                </li>
                <li>
                  In the event of breach of any of the Terms being evidenced or
                  reasonably ascertained from our investigation or if there is
                  reasonable belief, in our sole and absolute discretion, that
                  your continued access to the Web Portal is illegal, or
                  detrimental to the interests of the BCCI, our other users or
                  the general public or that your intentional actions, either
                  directly or indirectly, caused a malfunction or disruption of
                  the Web Portal or Games or any associated infrastructure, we
                  may in our sole discretion take any or all of the following
                  actions:
                  <ul className="m11c-style--lower-roman">
                    <li>
                      Restrict Games between users suspected of colluding or
                      cheating;
                    </li>
                    <li>
                      Permanently or temporarily suspend your user account on
                      the Web Portal and disqualify you from all Games you have
                      been entered into;
                    </li>
                    <li>
                      Withhold any prize that you may otherwise have won in
                      accordance with these Terms;
                    </li>
                    <li>
                      Demand damages for breach and take appropriate civil
                      action to recover such damages; and/or Initiate
                      prosecution for violations that amount to offences in law.
                    </li>
                  </ul>
                </li>
                <li>
                  Additionally, in the event of committing material breach
                  hereof, we reserve the right to bar you from future
                  registration on the Web Portal and/or for the purpose of
                  participating in the Games.
                </li>
                <li>
                  The decision of the BCCI on the action to be taken as a
                  consequence of breach shall be final and binding on you. Any
                  action taken by the BCCI shall be without prejudice to our
                  other rights and remedies available in law or equity.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>9. Infringement of Copyright</span>
          </div>
          <div className="m11c-static__content">
            <p>
              In good faith, if you have reason to believe that any work
              copyrighted by you has been reproduced, embedded, or linked
              without any authorization on this Web Portal or within any Game,
              in a manner that constitutes an infringement of your copyright,
              please compile the following information and email to:
              <a href="mailto: ipl-support@my11circle.com">
                ipl-support@my11circle.com
              </a>
              .
            </p>
            <div className="m11c-ptSyt__notes">
              <ul className="m11c-style--lower-alpha">
                <li>
                  A clear identification of the copyrighted work allegedly
                  infringed;
                </li>
                <li>
                  A clear identification of the allegedly infringing material on
                  the Web Portal (with specific URL reference);
                </li>
                <li>
                  Your contact details: name, address, e-mail address and phone
                  number;
                </li>
                <li>
                  A statement that you believe, in good faith, that the use of
                  the copyrighted material allegedly infringed on the Web Portal
                  is not authorized by your agent or the law;
                </li>
                <li>Your signature or a signature of your authorized agent.</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>10. Applicable Law</span>
          </div>
          <div className="m11c-static__content">
            <p>
              This Web Portal, including the Content (including content provided
              by the user) and information contained herein, shall be governed
              by the laws of the Republic of India and the courts of Mumbai,
              India shall retain exclusive jurisdiction to entertain any
              proceedings in relation to any disputes arising out of the same.
              As such, the laws of India shall govern the legal notices, Privacy
              Policy and Games available on this Web Portal.
            </p>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>11. Information Gathered and Tracked</span>
          </div>
          <div className="m11c-static__content">
            <div className="m11c-ptSyt__notes">
              <ul>
                <li>
                  Information submitted on the Web Portal is stored in a
                  database. Specifically, we store the name, e-mail address and
                  contact number supplied by users/visitors to our Web Portal
                  who wish to receive certain free services from the BCCI,
                  including but not limited to fixture lists and squad updates.
                  We also use such information to send out occasional
                  promotional materials, including alerts on new Games or
                  services available. The use, collection and disclosure of any
                  Information submitted on the Web Portal shall be subject to
                  the privacy policy of the Web Portal (accessible here) (“
                  <a href="https://fantasy.iplt20.com/classic/more/privacy_policy">
                    Privacy Policy
                  </a>
                  ”). Notwithstanding anything contained in the Privacy Policy,
                  with respect to users aged less than 18 years of age as on the
                  date accessing the Web Portal or participating in the Games,
                  such users will be permitted to use the Web Portal,
                  participate in the Games and will be eligible to win prizes
                  provided such user obtains the consent of his/her parent or
                  lawful guardian; the BCCI reserves the right to seek written
                  documentation of such consent of the parent or lawful guardian
                  at any time as a condition to such user’s continued use of the
                  Web Portal, participation in the Games or receipt of prizes
                  pursuant thereto.
                </li>
                {/* <ul>
                  <li>
                    All prizes are non-transferable and cannot be delivered in
                    the name of any third party other than the winner
                    themselves.
                  </li>
                  <li>All prizes will be delivered in India only. </li>
                  <li>
                    All costs till delivery of the car shall be borne by Sporta
                    Technologies Private Limited
                  </li>
                  <li>
                    Sporta Technologies Private Limited is not responsible for
                    any costs of maintenance once the car has been handed over
                    to the winner.
                  </li>
                  <li>
                    The delivery timeline of the car shall be subject to
                    availability and registration of the nearest authorized
                    dealership.
                  </li>
                  <li>
                    Winner shall be solely liable for submission of all required
                    documents at the time of receiving the car
                  </li>
                  <li>
                    The list of required documents shall be communicated to the
                    Winner by Sporta Technologies Private Limited.
                  </li>
                  <li>
                    The list of required documents shall be communicated to the
                    Winner by Sporta Technologies Private Limited.
                  </li>
                  <li>
                    Upon delivery and acceptance of the car by the Winner,
                    Sporta Technologies Private Limited is discharged of all its
                    liabilities hereunder.
                  </li>
                </ul> */}
              </ul>
            </div>
          </div>
        </div>

        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>12. Sub-Contractors</span>
          </div>
          <div className="m11c-static__content">
            <div className="m11c-ptSyt__notes">
              <ul>
                <li>
                  The BCCI may engage one or more third party service providers
                  and contractors for the development and operation of the Games
                  and the tabulation of results. In such case, the BCCI may
                  share the information submitted on the Web Portal to such
                  third-party service providers and shall ensure that such
                  third-party service providers are subject to restrictions
                  concerning data protection and non-disclosure (in relation to
                  any personally identifiable information so transmitted) of a
                  standard not less than as provided in the Privacy Policy. The
                  user hereby consents to the transmission and disclosure of
                  such information to such third parties.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>13. Complaints and Grievances</span>
          </div>
          <div className="m11c-static__content">
            <div className="m11c-ptSyt__notes">
              <ul className="m11c-style--upper-alpha">
                <li>
                  If you have a complaint or concern relating to the Games on
                  the Web Portal, you should contact the customer support team
                  using the following email address:
                  <a href="mailto: ipl-support@my11circle.com">
                    ipl-support@my11circle.com
                  </a>
                  . Complaints should be made as soon as practicable after
                  circumstances arise that cause you to have a complaint.
                </li>
                <li>
                  You accept that any complaints and disputes are and remain
                  confidential both whilst a resolution is sought and
                  afterwards. You agree that you shall not disclose the
                  existence, nature or any detail of any complaint or dispute to
                  any third party.
                </li>
                <li>
                  The customer support team will make efforts to resolve
                  complaints within a reasonable time period. BCCI’s decision on
                  complaints shall be final and binding on you.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpTermsNConditions;
